import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

import { PremiumOfferCard } from '../PremiumOfferCard'

export const PremiumBundleCardSkeleton = () => {
  return (
    <PremiumOfferCard
      heading={
        <Box flexDirection="row" gap="s4">
          {range(3).map((index) => (
            <Box
              key={`premium-bundle-avatar-skeleton-${index}`}
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
              borderRadius={{ all: 'rel1000' }}
              overflowY="hidden"
              overflowX="hidden"
            >
              <Skeleton width="s32" height="s32" />
            </Box>
          ))}
        </Box>
      }
      body={
        <>
          <Skeleton width={sample(['s140', 's240', 's200'])} height="s16" />
        </>
      }
      footer={
        <>
          <Skeleton width="s96" height="s16" />
          <Skeleton width="s96" height="s32" />
        </>
      }
    />
  )
}
